import { render, staticRenderFns } from "./AreaEmbargadaIbamaLista.vue?vue&type=template&id=40c8cd03&lang=pug"
import script from "./AreaEmbargadaIbamaLista.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaIbamaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports